module.exports = __webpack_public_path__ + "img/Winner-4.8a7ecf07.jpg";